module.exports = __webpack_public_path__ + "img/28.58928277.webp";